module.exports = __webpack_public_path__ + "img/no-gps-marker.3de0d889.svg";